import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.008 5H2.992C2.456 5 2 5.451 2 6.007v11.986A.999.999 0 0 0 2.992 19h18.016c.536 0 .992-.451.992-1.007V6.007A.999.999 0 0 0 21.008 5zM3 7.353l5.571 5.076-.071.071L3 17V7.353zM12.002 18H3.36l.276-.226 5.5-4.5.193-.158 1.637 1.491c.284.258.647.389 1.012.395.381.006.764-.125 1.06-.395l1.637-1.491.193.158 5.5 4.5.276.226h-8.642zM21 17l-5.5-4.5-.071-.071L21 7.353V17zm-8.636-3.132a.56.56 0 0 1-.728 0L3 6h18l-8.636 7.868z"
});

var SvgEmail = function SvgEmail(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgEmail;